export const GENERATED_MIDI = [
    {
        "id": "midi-gen-0001",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In favor of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In good shape; or be the right size",
                "answer": "FIT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Little oval flute, the \"sweet potato\"",
                "answer": "OCARINA",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Taken away",
                "answer": "REMOVED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Strikes from the record",
                "answer": "DELETES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Neither the best nor the worst",
                "answer": "AVERAGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Corn-husk-wrapped Mexican fare",
                "answer": "TAMALES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "In the past; \"long ___\"",
                "answer": "AGO",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "\"Message received,\" on the radio",
                "answer": "ROGER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Everything turns on it",
                "answer": "PIVOTAL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Soda, in the Midwest; Grandpa, to some",
                "answer": "POP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "\"Ready, ___, go!\"",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0002",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not in; stepped ___",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put something to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What geometry students prove",
                "answer": "THEOREM",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The knack for doing something",
                "answer": "ABILITY",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Metal of many a soup can",
                "answer": "TIN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Large in size",
                "answer": "BIG",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"In ___ with\" (matching)",
                "answer": "KEEPING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A peach's stone",
                "answer": "PIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What squeaky hinges need",
                "answer": "OIL",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Rich for growing, as soil",
                "answer": "FERTILE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Plump; the opposite of thin",
                "answer": "FAT",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "The sheltered side, away from the wind",
                "answer": "LEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Have a meal",
                "answer": "EAT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Afternoon cuppa",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "A male cat",
                "answer": "TOM",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Up to now",
                "answer": "YET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0003",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A friendly feud",
                "answer": "RIVALRY",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Lurches from side to side",
                "answer": "CAREENS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A stop light’s color",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bring to life",
                "answer": "ANIMATE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Worthiness deserving of reward or praise",
                "answer": "MERIT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Held in the highest regard",
                "answer": "REVERED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Least lovely, like a famous duckling",
                "answer": "UGLIEST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "An empty space between",
                "answer": "GAP",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "The salty blue expanse",
                "answer": "SEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Give it a ___ (make an attempt)",
                "answer": "TRY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Your other half at the dance",
                "answer": "PARTNER",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0004",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On behalf of; in favor of",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Looked after, as a hungry crowd",
                "answer": "FED",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Wear out with too much service",
                "answer": "OVERUSE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Proved wrong",
                "answer": "REFUTED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "By way of; passing through",
                "answer": "VIA",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Thin fine-wood surfaces",
                "answer": "VENEERS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The tendency to stay put",
                "answer": "INERTIA",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Sum up; tack on",
                "answer": "ADD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The day before a holiday",
                "answer": "EVE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The finish",
                "answer": "END",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Spelled out clearly",
                "answer": "DEFINED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Under the weather",
                "answer": "ILL",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Twelve inches of straight edge",
                "answer": "RULER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Where the lamps plug in",
                "answer": "OUTLETS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Belonging to us",
                "answer": "OUR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Make practical of a tool",
                "answer": "USE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A small tear in your trousers",
                "answer": "RIP",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A stop sign’s color",
                "answer": "RED",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0006",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In support of; not against",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A friendly feud",
                "answer": "RIVALRY",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Springtime month of flowers",
                "answer": "MAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sleek forest cousins of the weasel",
                "answer": "MARTENS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bring to life",
                "answer": "ANIMATE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Worthiness deserving of reward",
                "answer": "MERIT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Looks up to greatly",
                "answer": "REVERES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "What hangs in a gallery",
                "answer": "ART",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Least lovely, like a famous duckling",
                "answer": "UGLIEST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "An empty space between",
                "answer": "GAP",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Give it a go",
                "answer": "TRY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Your other half at the dance",
                "answer": "PARTNER",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0007",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A little word before a noun",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A pair, in number",
                "answer": "TWO",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Notably hairy",
                "answer": "HIRSUTE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Seals all around",
                "answer": "ENCASES",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A guide to find the way",
                "answer": "MAP",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Playground name for the unkind",
                "answer": "MEANIES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Put in order; set flowers just so",
                "answer": "ARRANGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Come out on top",
                "answer": "WIN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Rows of apple trees",
                "answer": "ORCHARD",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "\"Beg your pardon?\"",
                "answer": "HUH",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Hot steam room of Finnish origin",
                "answer": "SAUNA",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Shoving forward",
                "answer": "PUSHING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Settle the bill",
                "answer": "PAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came into possession of; \"I ___ a letter\"",
                "answer": "GOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Past tense of eat",
                "answer": "ATE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Just so; agreed",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Put the table for dinner",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0009",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good purpose; make ___ of",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Take a look",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Place in safe hands",
                "answer": "ENTRUST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A spider's handiwork",
                "answer": "WEB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bobcat or lynx",
                "answer": "WILDCAT",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Where you lay your head at night",
                "answer": "BED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Lost in quiet thought",
                "answer": "PENSIVE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put to rest, as a question",
                "answer": "SETTLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Took away; got the place clear of",
                "answer": "RID",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What a bad check did",
                "answer": "BOUNCED",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Take one after the performance",
                "answer": "BOW",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Where the actors are during the play",
                "answer": "ONSTAGE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Soaked through with water",
                "answer": "WET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Two thousand pounds, in weight",
                "answer": "TON",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0011",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Not at home",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What geometry students prove",
                "answer": "THEOREM",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The knack for doing something",
                "answer": "ABILITY",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A grocery sack",
                "answer": "BAG",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"In ___ with\" (matching)",
                "answer": "KEEPING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A peach's stone",
                "answer": "PIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What squeaky hinges need",
                "answer": "OIL",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Rich for growing, as soil",
                "answer": "FERTILE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Plump, carrying extra weight",
                "answer": "FAT",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Sheltered side, away from the wind",
                "answer": "LEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Have a bite of breakfast or lunch",
                "answer": "EAT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Afternoon brew",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Cat's nickname, or Mark Twain's Sawyer",
                "answer": "TOM",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Up to now",
                "answer": "YET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0013",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Do something, or a play’s division",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flowers pinned on for the prom",
                "answer": "CORSAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Birdsong chatter",
                "answer": "TWITTER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Soap unit, or a tavern",
                "answer": "BAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Weight that steadies a ship",
                "answer": "BALLAST",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "An artist's studio",
                "answer": "ATELIER",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Cardinal colour",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "This very moment",
                "answer": "NOW",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bored a hole; ran the troops through practice",
                "answer": "DRILLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Brightly burning, as a candle",
                "answer": "LIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Quiet and motionless",
                "answer": "STILL",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Fuzzy brown marsh plant on a stalk",
                "answer": "CATTAIL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Cover for the head with a brim",
                "answer": "CAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Put down gently",
                "answer": "LAY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Give it a go; make an attempt",
                "answer": "TRY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0014",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "J",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good ___, make the most of",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put down in place, as a table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rubbing out pencil marks",
                "answer": "ERASING",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The opposite of peace",
                "answer": "WAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A listening device on the line",
                "answer": "WIRETAP",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A stop light’s color",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Took the leading role",
                "answer": "STARRED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Go faster than a walk",
                "answer": "RUN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Take to court",
                "answer": "SUE",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Built with hinges, like a folding rule",
                "answer": "JOINTED",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What you're paid to do",
                "answer": "JOB",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Be in debt",
                "answer": "OWE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Belonging to oneself",
                "answer": "OWN",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Plead on bended knee",
                "answer": "BEG",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "It sizzles on the stove",
                "answer": "PAN",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0015",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word meaning \"in favor of\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A friendly feud",
                "answer": "RIVALRY",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Mix drinks for a living",
                "answer": "BARTEND",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Word of agreement; a nod of approval",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bring to life",
                "answer": "ANIMATE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Worthiness deserving of reward or praise",
                "answer": "MERIT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Looks up to greatly",
                "answer": "REVERES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "What hangs in a gallery",
                "answer": "ART",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Least lovely, like a famous duckling",
                "answer": "UGLIEST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "An empty space between",
                "answer": "GAP",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "The salty blue expanse",
                "answer": "SEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "An old title for a Turkish governor",
                "answer": "TRY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Your other half at the dance",
                "answer": "PARTNER",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0016",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Take the stage",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Tell the story aloud",
                "answer": "NARRATE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A head-in-the-clouds sort",
                "answer": "DREAMER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Average score on a golf hole",
                "answer": "PAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "\"___ out\" (dwindled away)",
                "answer": "PETERED",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Neither the best nor the worst",
                "answer": "AVERAGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A stop sign’s color",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Picked up the check; doctored",
                "answer": "TREATED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "One who runs in a race",
                "answer": "RACER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "They caught the moment on film",
                "answer": "CAMERAS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Cover for the head with a brim",
                "answer": "CAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A man's male child",
                "answer": "SON",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0017",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work or make ___ of",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Catch sight of",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Place in safe hands",
                "answer": "ENTRUST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A spider's handiwork",
                "answer": "WEB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bobcat or lynx",
                "answer": "WILDCAT",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The day before a holiday",
                "answer": "EVE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Where you tuck in for the night",
                "answer": "BED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Lost in quiet thought",
                "answer": "PENSIVE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put to rest, as a question",
                "answer": "SETTLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Cleared away; got the room free of clutter",
                "answer": "RID",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What a bad check did",
                "answer": "BOUNCED",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Float gently up and down on the water",
                "answer": "BOB",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Where the actors are during the play",
                "answer": "ONSTAGE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A friendly wager",
                "answer": "BET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "2,000 pounds",
                "answer": "TON",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0018",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Time ___,\" called by an umpire",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Make ___ of, put to a purpose",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What geometry students prove",
                "answer": "THEOREM",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Past tense of eat",
                "answer": "ATE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The knack for doing something",
                "answer": "ABILITY",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Metal of many a soup can",
                "answer": "TIN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Large in size",
                "answer": "BIG",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"In ___ with\" (matching)",
                "answer": "KEEPING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A peach's stone",
                "answer": "PIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What squeaky hinges need",
                "answer": "OIL",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Rich for growing, as soil",
                "answer": "FERTILE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "The sheltered side, away from the wind",
                "answer": "LEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Have a bite of food",
                "answer": "EAT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Afternoon drink",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "A male sheep",
                "answer": "RAM",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Up to now",
                "answer": "YET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0019",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "In place of, in a swap",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Plump; the opposite of thin",
                "answer": "FAT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Little oval flute, the \"sweet potato\"",
                "answer": "OCARINA",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Taken away",
                "answer": "REMOVED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Strikes from the record",
                "answer": "DELETES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Neither the best nor the worst",
                "answer": "AVERAGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Corn-husk-wrapped Mexican fare",
                "answer": "TAMALES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "In the past; \"long ___\"",
                "answer": "AGO",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "\"Message received,\" on the radio",
                "answer": "ROGER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Everything turns on it",
                "answer": "PIVOTAL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Soda, in the Midwest; Grandpa, to some",
                "answer": "POP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Put in place, as a table for dinner",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0020",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On the other hand…",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work; make good of",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Playhouse, spelled the British way",
                "answer": "THEATRE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bashful and timid",
                "answer": "SHY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hi-fi sets",
                "answer": "STEREOS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Belonging to that fellow",
                "answer": "HIS",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Up to now",
                "answer": "YET",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Farthest down",
                "answer": "DEEPEST",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A peach's stone",
                "answer": "PIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Irish bird dogs",
                "answer": "SETTERS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Have your dinner",
                "answer": "EAT",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "The blue expanse overhead",
                "answer": "SKY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0021",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make practical of; employ",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Place down in position",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "They're at the ends of pencils",
                "answer": "ERASERS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bessie in the barn",
                "answer": "COW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A body of advisors",
                "answer": "COUNCIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The face one shows the world",
                "answer": "PERSONA",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A daredevil's feat",
                "answer": "STUNT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Figures on pedestals",
                "answer": "STATUES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "It rises in the morning",
                "answer": "SUN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A cut-out lettering guide",
                "answer": "STENCIL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A grand columned porch",
                "answer": "PORTICO",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Allow; permit",
                "answer": "LET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0023",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to good purpose",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Take a peek",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Place in safe hands",
                "answer": "ENTRUST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A spider's handiwork",
                "answer": "WEB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bobcat or lynx",
                "answer": "WILDCAT",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Where you lay your head at night",
                "answer": "BED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Lost in quiet thought",
                "answer": "PENSIVE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put to rest, as a question",
                "answer": "SETTLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Took away; got the place clear of",
                "answer": "RID",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What a bad check did",
                "answer": "BOUNCED",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "A young fellow",
                "answer": "BOY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Where the actors are during the play",
                "answer": "ONSTAGE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Up to now",
                "answer": "YET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Two thousand pounds, in weight",
                "answer": "TON",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0024",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However; on the contrary",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A grocery sack",
                "answer": "BAG",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to good ___",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Warnings of harm",
                "answer": "THREATS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Slide down a snowy slope on two long boards",
                "answer": "SKI",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Quicker on the uptake",
                "answer": "SMARTER",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "One's range of knowledge",
                "answer": "KEN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Belonging to it",
                "answer": "ITS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Came together, in past tense",
                "answer": "MET",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Berliners and Bavarians",
                "answer": "GERMANS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Damage, as a smooth finish",
                "answer": "MAR",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "You hear with it",
                "answer": "EAR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Bare-bones simple",
                "answer": "SPARTAN",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What you look up at on a clear day",
                "answer": "SKY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "In times past; previously",
                "answer": "AGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "This very moment",
                "answer": "NOW",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A set of tools or parts",
                "answer": "KIT",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Agreeable answer, the opposite of no",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0025",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A little word before \"end\" and \"best\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A pair’s count",
                "answer": "TWO",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Notably hairy",
                "answer": "HIRSUTE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Seals all around",
                "answer": "ENCASES",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Little caps, some with propellers",
                "answer": "BEANIES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Put in order; set flowers just so",
                "answer": "ARRANGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Father, fondly",
                "answer": "DAD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Come out on top",
                "answer": "WIN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Rows of apple trees",
                "answer": "ORCHARD",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "\"Beg your pardon?\"",
                "answer": "HUH",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Hot steam room of Finnish origin",
                "answer": "SAUNA",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Shoving forward",
                "answer": "PUSHING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Settle the bill",
                "answer": "PAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came into possession of; \"I ___ a letter\"",
                "answer": "GOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Word of agreement; a nod of approval",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Put in place; ready to go",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0026",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take action; perform on stage",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The hi-fi speaker for the high notes",
                "answer": "TWEETER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A grocery sack",
                "answer": "BAG",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "They back the horses",
                "answer": "BETTORS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The Almighty",
                "answer": "GOD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Uncooked, as vegetables",
                "answer": "RAW",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put up, as a barn",
                "answer": "ERECTED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Whiskered pet that purrs on your lap",
                "answer": "CAT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Take in food at the table",
                "answer": "EAT",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Sailors' arm decorations",
                "answer": "TATTOOS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Money left for the waiter",
                "answer": "TIP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "The blue above us on a clear day",
                "answer": "SKY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0027",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"A letter ___ you arrived today\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A friendly feud",
                "answer": "RIVALRY",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Soap unit, or a tavern",
                "answer": "BAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Mix drinks for a living",
                "answer": "BARTEND",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The color of a ripe tomato",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Bring to life",
                "answer": "ANIMATE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Worthiness deserving of reward",
                "answer": "MERIT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Held in the highest regard",
                "answer": "REVERED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "What hangs in a gallery",
                "answer": "ART",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Least lovely, like a famous duckling",
                "answer": "UGLIEST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "An empty space between",
                "answer": "GAP",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "The salty blue expanse",
                "answer": "SEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Give it a go; \"just ___\"",
                "answer": "TRY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Your other half at the dance",
                "answer": "PARTNER",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0028",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "I",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This bouquet is ___ you, dear\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "In good shape; or be the right size",
                "answer": "FIT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Little oval flute, the \"sweet potato\"",
                "answer": "OCARINA",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rested peacefully",
                "answer": "REPOSED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "One of a pair of dice",
                "answer": "DIE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Points the way; runs the picture",
                "answer": "DIRECTS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The tendency to stay put",
                "answer": "INERTIA",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The very last part",
                "answer": "END",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A country lodging",
                "answer": "INN",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Narrowed toward the end",
                "answer": "TAPERED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "The day before a holiday",
                "answer": "EVE",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "One who wanders far and wide",
                "answer": "ROVER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Cuts exactly in half",
                "answer": "BISECTS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Float gently up and down on the water",
                "answer": "BOB",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Group of related items, like dishes or tools",
                "answer": "SET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Took a seat",
                "answer": "SAT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0029",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Three cheers ___ the winner!\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The newest soldier in boot camp",
                "answer": "RECRUIT",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A small tear in your trousers",
                "answer": "RIP",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Gathering of the herd",
                "answer": "ROUNDUP",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A country lodging",
                "answer": "INN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A dog or cat at home",
                "answer": "PET",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Windflower of the garden; also a sea creature",
                "answer": "ANEMONE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Low sounds of complaint",
                "answer": "MOANS",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Tell in detail; tally again",
                "answer": "RECOUNT",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Apart, in the old wedding phrase",
                "answer": "ASUNDER",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Every last one",
                "answer": "ALL",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "\"Wait and ___\"",
                "answer": "SEE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A fire engine’s color",
                "answer": "RED",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Free time for rest and pleasure",
                "answer": "LEISURE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Allow or permit",
                "answer": "LET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0030",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However; on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Soap unit, or a tavern",
                "answer": "BAR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work, as a tool",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The rumble after the flash",
                "answer": "THUNDER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The lady",
                "answer": "SHE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "High ___ (a cheerful mood)",
                "answer": "SPIRITS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "It tops things off",
                "answer": "HAT",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "You look with it",
                "answer": "EYE",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Settle the bill",
                "answer": "PAY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bring back together",
                "answer": "REUNITE",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "This very moment",
                "answer": "NOW",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "And not; neither this",
                "answer": "NOR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "She helps bring babies into the world",
                "answer": "MIDWIFE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Folded paper guide for finding your way",
                "answer": "MAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A small charge, as for a service",
                "answer": "FEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Have a meal",
                "answer": "EAT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Hot drink steeped from leaves in a cup",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Place the table before dinner",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0031",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single deed or a part of a play",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pennies, nickels, and dimes together",
                "answer": "COINAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The one holding the stopwatch at the gym",
                "answer": "TRAINER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The diner's blue-plate offering",
                "answer": "SPECIAL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The red bit in a green olive",
                "answer": "PIMENTO",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "\"Neither here ___ there\"",
                "answer": "NOR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Jeweled crowns",
                "answer": "DIADEMS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A sister's daughter",
                "answer": "NIECE",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Staffing, as a post",
                "answer": "MANNING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A guide to find the way",
                "answer": "MAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Come to have",
                "answer": "GET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Past tense of eat",
                "answer": "ATE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0032",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Arrange in place, like a hen on her eggs",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Have a bite of breakfast or lunch",
                "answer": "EAT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Grew threefold",
                "answer": "TREBLED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Tear apart at a seam",
                "answer": "RIP",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Plunderers of long ago",
                "answer": "RAIDERS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "An artist's studio",
                "answer": "ATELIER",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Guided the way, in the past tense",
                "answer": "LED",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Where you tuck in for the night",
                "answer": "BED",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A volcano's collapsed bowl",
                "answer": "CALDERA",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long while back",
                "answer": "AGO",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Whichever one at all",
                "answer": "ANY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0033",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make good of; put to work",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Groan of distaste",
                "answer": "UGH",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sign the back of, as a check",
                "answer": "ENDORSE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Coming out of sleep",
                "answer": "AWAKING",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Rodent that scurries through the cellar",
                "answer": "RAT",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "You wink with it",
                "answer": "EYE",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "\"Make way!\"; a ship's boarding ramp",
                "answer": "GANGWAY",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Shred cheese; the fireplace's iron frame",
                "answer": "GRATE",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Drink plenty of water",
                "answer": "HYDRATE",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "\"___ arts\" (judo and karate)",
                "answer": "MARTIAL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Was introduced to; \"We ___ years ago\"",
                "answer": "MET",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Permit, or a hindrance in tennis",
                "answer": "LET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Quietly tapped, as a sonar signal",
                "answer": "ESSENCE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Word before \"end\" or \"best\"",
                "answer": "THE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Come to have",
                "answer": "GET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0034",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"This song is just ___ you\"",
                "answer": "FOR",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Plump, carrying extra weight",
                "answer": "FAT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Little oval flute, the \"sweet potato\"",
                "answer": "OCARINA",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Rested peacefully",
                "answer": "REPOSED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "One of a pair of dice",
                "answer": "DIE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Points the way; runs the picture",
                "answer": "DIRECTS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The tendency to stay put",
                "answer": "INERTIA",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The finish, where things stop",
                "answer": "END",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A country lodging",
                "answer": "INN",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Narrowed toward the end",
                "answer": "TAPERED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "The night before a holiday",
                "answer": "EVE",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "One who wanders far and wide",
                "answer": "ROVER",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Cuts exactly in half",
                "answer": "BISECTS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Float gently up and down on the water",
                "answer": "BOB",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Group of matching dishes, or a tennis division",
                "answer": "SET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Fasten a shoelace in a bow",
                "answer": "TIE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Was seated, in the past tense",
                "answer": "SAT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0035",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work; employ",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Groan of distaste",
                "answer": "UGH",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sign the back of, as a check",
                "answer": "ENDORSE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Coming out of sleep",
                "answer": "AWAKING",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Cheese-loving rodent",
                "answer": "RAT",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "You see with it",
                "answer": "EYE",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "\"Make way!\"; a ship's boarding ramp",
                "answer": "GANGWAY",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "Shred cheese; the fireplace's iron frame",
                "answer": "GRATE",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Drink plenty of water",
                "answer": "HYDRATE",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Incomplete; or fond (of)",
                "answer": "PARTIAL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "A dog or cat at home",
                "answer": "PET",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Permit; rent out",
                "answer": "LET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Quietly tapped, as a sonar signal",
                "answer": "ESSENCE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Word before 'best' or 'most'",
                "answer": "THE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Come to have",
                "answer": "GET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0036",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "J",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"All ___ one\" — that is, except one",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Forbid outright",
                "answer": "BAN",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "To that; \"attached ___\" (formal)",
                "answer": "THERETO",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "What you're paid to do",
                "answer": "JOB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Built with hinges, like a folding rule",
                "answer": "JOINTED",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Have as your very ___",
                "answer": "OWN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Plead on bended knee",
                "answer": "BEG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Be in debt",
                "answer": "OWE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Requiring",
                "answer": "NEEDING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Owed by now",
                "answer": "DUE",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Go faster than a walk",
                "answer": "RUN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "The fastest cat on earth",
                "answer": "CHEETAH",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Bessie in the barn",
                "answer": "COW",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "\"Beg your pardon?\"",
                "answer": "HUH",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "In the past; \"long ___\"",
                "answer": "AGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Fresh from the oven",
                "answer": "HOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Word an umpire shouts at the plate",
                "answer": "OUT",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "\"Guess ___ came to dinner\"",
                "answer": "WHO",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Tiny spot on the page",
                "answer": "DOT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0037",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word before \"end\" or \"beginning\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A clock has this many pointing hands",
                "answer": "TWO",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Notably hairy",
                "answer": "HIRSUTE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Seals all around",
                "answer": "ENCASES",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Little caps, some with propellers",
                "answer": "BEANIES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Put in order; set flowers just so",
                "answer": "ARRANGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A child's affectionate name for father",
                "answer": "DAD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Come out on top",
                "answer": "WIN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Rows of apple trees",
                "answer": "ORCHARD",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "\"Beg your pardon?\"",
                "answer": "HUH",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Hot steam room of Finnish origin",
                "answer": "SAUNA",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "In a great hurry",
                "answer": "RUSHING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A beam of sunshine",
                "answer": "RAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came into possession of; \"I ___ a letter\"",
                "answer": "GOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Place down, as the table for dinner",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0038",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Last ___ not least\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put something to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Showed gratitude to",
                "answer": "THANKED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A grocery sack",
                "answer": "BAG",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Small breeds of chicken",
                "answer": "BANTAMS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The Almighty",
                "answer": "GOD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "In times past; previously",
                "answer": "AGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Ached with longing",
                "answer": "YEARNED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "'Whether or ___'",
                "answer": "NOT",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Clumsy and ill at ease",
                "answer": "AWKWARD",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came out on top; was victorious",
                "answer": "WON",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "A bird's home up in a tree",
                "answer": "DRY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Damage, as a smooth finish",
                "answer": "MAR",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The finish or conclusion of a story",
                "answer": "END",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0039",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make practical of a tool",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Place the plates and forks on the table",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "They're at the ends of pencils",
                "answer": "ERASERS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bessie in the barn",
                "answer": "COW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A body of advisors",
                "answer": "COUNCIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The face one shows the world",
                "answer": "PERSONA",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Figures on pedestals",
                "answer": "STATUES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "A wrongdoing, from the pulpit",
                "answer": "SIN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A cut-out lettering guide",
                "answer": "STENCIL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A grand columned porch",
                "answer": "PORTICO",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Just so; agreed",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Allow; permit",
                "answer": "LET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0040",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Most common little word in English, before \"end\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A couple, in number",
                "answer": "TWO",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Notably hairy",
                "answer": "HIRSUTE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sealed all around",
                "answer": "ENCASED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Little caps, some with propellers",
                "answer": "BEANIES",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Put in order; set flowers just so",
                "answer": "ARRANGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Father, fondly",
                "answer": "DAD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Come out on top",
                "answer": "WIN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Rows of apple trees",
                "answer": "ORCHARD",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "\"Beg your pardon?\"",
                "answer": "HUH",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Hot steam room of Finnish origin",
                "answer": "SAUNA",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Shoving forward",
                "answer": "PUSHING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Average score on a golf hole",
                "answer": "PAR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came into possession of; \"I ___ a letter\"",
                "answer": "GOT",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Had a meal",
                "answer": "ATE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Cardinal colour",
                "answer": "RED",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Adjust the clock to the right time",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0041",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put a tool to work",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Have a look",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Place in safe hands",
                "answer": "ENTRUST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A spider's handiwork",
                "answer": "WEB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A bobcat or lynx",
                "answer": "WILDCAT",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The day before a holiday",
                "answer": "EVE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Where you lay your head at night",
                "answer": "BED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Lost in quiet thought",
                "answer": "PENSIVE",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Put to rest, as a question",
                "answer": "SETTLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "Cleared away; got the room free of clutter",
                "answer": "RID",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Sprang like a cat",
                "answer": "POUNCED",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Soda, in the Midwest; Grandpa, to some",
                "answer": "POP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Where the actors are during the play",
                "answer": "ONSTAGE",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A dog or cat at home",
                "answer": "PET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "2,000 pounds",
                "answer": "TON",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0042",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Set eyes on",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "That lady",
                "answer": "SHE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "You hear with it",
                "answer": "EAR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Follow the example of",
                "answer": "EMULATE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Fuzzy brown marsh plant on a stalk",
                "answer": "CATTAIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Easter dinner centerpiece; a showoff actor",
                "answer": "HAM",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long while back",
                "answer": "AGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Blew its top, as a volcano",
                "answer": "ERUPTED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "It's mightier than the sword, they say",
                "answer": "PEN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Allow or permit",
                "answer": "LET",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Flow outward from a source",
                "answer": "EMANATE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Gentlemen",
                "answer": "MEN",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "The finish or close",
                "answer": "END",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Come to have",
                "answer": "GET",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A charged particle",
                "answer": "ION",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Guided by the hand; past tense of lead",
                "answer": "LED",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0043",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Perform on a stage",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Flowers pinned on for the prom",
                "answer": "CORSAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Birdsong chatter",
                "answer": "TWITTER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Soap unit, or a tavern",
                "answer": "BAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "It rises at the county fair",
                "answer": "BALLOON",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Nail-polish remover's main ingredient",
                "answer": "ACETONE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A stop light’s color",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "This very moment",
                "answer": "NOW",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bored a hole; ran the troops through practice",
                "answer": "DRILLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Brightly burning, as a candle",
                "answer": "LIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "One of a circus walker's tall poles",
                "answer": "STILT",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Sailors' arm decorations",
                "answer": "TATTOOS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Gentle pat or faucet",
                "answer": "TAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "\"Ready, ___, go!\"",
                "answer": "SET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "What the fisherman casts",
                "answer": "NET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0046",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work for a purpose",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put the table for dinner",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "They're at the ends of pencils",
                "answer": "ERASERS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bessie in the barn",
                "answer": "COW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A body of advisors",
                "answer": "COUNCIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The face one shows the world",
                "answer": "PERSONA",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A daredevil's feat",
                "answer": "STUNT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Figures on pedestals",
                "answer": "STATUES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "It rises in the morning",
                "answer": "SUN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A cut-out lettering guide",
                "answer": "STENCIL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A ship captain's daily record",
                "answer": "LOG",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A grand columned porch",
                "answer": "PORTICO",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "It runs from hip to ankle",
                "answer": "LEG",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0047",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "However, on the other hand",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Louisville Slugger, for one",
                "answer": "BAT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to good ___, make the most of",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Warnings of harm",
                "answer": "THREATS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Notice with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "High ___ (a cheerful mood)",
                "answer": "SPIRITS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Have your dinner",
                "answer": "EAT",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What you see with",
                "answer": "EYE",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Settle the bill",
                "answer": "PAY",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The wood-eating pest",
                "answer": "TERMITE",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "What you look at the world with",
                "answer": "MAD",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Without hesitation",
                "answer": "READILY",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Uncooked, as vegetables",
                "answer": "RAW",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A fib; or stretch out",
                "answer": "LIE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Up to now",
                "answer": "YET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "What hangs in a gallery",
                "answer": "ART",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Place the table for supper",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0048",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single scene in a stage play",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pennies, nickels, and dimes together",
                "answer": "COINAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Schooled in the work",
                "answer": "TRAINED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The diner's blue-plate offering",
                "answer": "SPECIAL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The red bit in a green olive",
                "answer": "PIMENTO",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "And not; neither this",
                "answer": "NOR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Jeweled crowns",
                "answer": "DIADEMS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A sister's daughter",
                "answer": "NIECE",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Staffing, as a post",
                "answer": "MANNING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Damage, as a smooth finish",
                "answer": "MAR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Come to have",
                "answer": "GET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A stop sign’s color",
                "answer": "RED",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0049",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word that joins two contrasting ideas",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Forbid outright",
                "answer": "BAN",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work or make ___ of",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Foils the villain's plan",
                "answer": "THWARTS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Took a seat",
                "answer": "SAT",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Where butterflies flutter",
                "answer": "STOMACH",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "One more than nine",
                "answer": "TEN",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fasten a shoelace in a bow",
                "answer": "TIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Fresh arrival in the nursery",
                "answer": "NEWBORN",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A life story, for short",
                "answer": "BIO",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Line up the shot",
                "answer": "AIM",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Where frogs are said to lodge",
                "answer": "THROATS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Soothing afternoon cup, often with lemon",
                "answer": "TEA",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Owned, in the past",
                "answer": "HAD",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Take in food at the table",
                "answer": "EAT",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Officer, informally",
                "answer": "COP",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Notices in the newspaper selling things, for short",
                "answer": "ADS",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Greeting to get attention",
                "answer": "HEY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0050",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take steps; do something",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pennies, nickels, and dimes together",
                "answer": "COINAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The one holding the stopwatch at the gym",
                "answer": "TRAINER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The diner's blue-plate offering",
                "answer": "SPECIAL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The red bit in a green olive",
                "answer": "PIMENTO",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Just so; agreed",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "\"Neither here ___ there\"",
                "answer": "NOR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Jeweled crowns",
                "answer": "DIADEMS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A sister's daughter",
                "answer": "NIECE",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "What makes strong tea pucker the mouth",
                "answer": "TANNINS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Gentle pat or faucet",
                "answer": "TAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Put down in place, as a table for dinner",
                "answer": "SET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0053",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "A single part of a play",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Notices in the newspaper selling things, for short",
                "answer": "ADS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Fine cooking, French style",
                "answer": "CUISINE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A crisp, flat Mexican snack",
                "answer": "TOSTADA",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Rugged Western mountain ranges",
                "answer": "SIERRAS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Farmland, measured out",
                "answer": "ACREAGE",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Word of agreement; a nod of approval",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "A twosome",
                "answer": "DUO",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "The nuns of a convent",
                "answer": "SISTERS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Stick a label on, or a game of chase",
                "answer": "TAG",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Look at fixedly with wide eyes",
                "answer": "STARE",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A drawing that explains",
                "answer": "DIAGRAM",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Sunrise to sunset",
                "answer": "DAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came together, in past tense",
                "answer": "MET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A vote of yes",
                "answer": "YEA",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Put in place, as a table for dinner",
                "answer": "SET",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0054",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "J",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "C",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make ___ of, put to a purpose",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Groan of distaste",
                "answer": "UGH",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Take to court",
                "answer": "SUE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Made possible",
                "answer": "ENABLED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "What you're paid to do",
                "answer": "JOB",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Carpenters of fine fittings",
                "answer": "JOINERS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Have as your very ___",
                "answer": "OWN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Plead on bended knee",
                "answer": "BEG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "It fires with a bang",
                "answer": "GUN",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Be in debt",
                "answer": "OWE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "One of the five senses",
                "answer": "HEARING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Took away; got the place clear of",
                "answer": "RID",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Where the potatoes are kept",
                "answer": "BIN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A volcano's collapsed bowl",
                "answer": "CALDERA",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "In times past; previously",
                "answer": "AGO",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Whichever one at all",
                "answer": "ANY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0055",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "N",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": 13
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take steps to get something done",
                "answer": "ACT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Bread ___ butter",
                "answer": "AND",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Pennies, nickels, and dimes together",
                "answer": "COINAGE",
                "row": 0,
                "col": 1,
                "length": 7
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The one holding the stopwatch at the gym",
                "answer": "TRAINER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The diner's blue-plate offering",
                "answer": "SPECIAL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The red bit in a green olive",
                "answer": "PIMENTO",
                "row": 0,
                "col": 5,
                "length": 7
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "\"Neither here ___ there\"",
                "answer": "NOR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Jeweled crowns",
                "answer": "DIADEMS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A wild animal's cozy hideaway",
                "answer": "DEN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A sister's daughter",
                "answer": "NIECE",
                "row": 3,
                "col": 1,
                "length": 5
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Browning in the sun",
                "answer": "TANNING",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Gentle pat or faucet",
                "answer": "TAP",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Come to have",
                "answer": "GET",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 14,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "Past tense of eat",
                "answer": "ATE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A parcel of land; plenty",
                "answer": "LOT",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0056",
        "size": "midi",
        "difficulty": "hard",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 15
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Put to work; make good of",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "\"___ and downs\"",
                "answer": "UPS",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Place down in position",
                "answer": "SET",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "They're at the ends of pencils",
                "answer": "ERASERS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bessie in the barn",
                "answer": "COW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A body of advisors",
                "answer": "COUNCIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "The face one shows the world",
                "answer": "PERSONA",
                "row": 1,
                "col": 0,
                "length": 7
            },
            {
                "number": 8,
                "direction": "down",
                "clue": "A set period of time; a limit",
                "answer": "STINT",
                "row": 1,
                "col": 3,
                "length": 5
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Figures on pedestals",
                "answer": "STATUES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "across",
                "clue": "A wrongdoing, from the pulpit",
                "answer": "SIN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A cut-out lettering guide",
                "answer": "STENCIL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 11,
                "direction": "down",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A ship captain's daily record",
                "answer": "LOG",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 15,
                "direction": "across",
                "clue": "A grand columned porch",
                "answer": "PORTICO",
                "row": 5,
                "col": 0,
                "length": 7
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "It runs from hip to ankle",
                "answer": "LEG",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0057",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "U",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "V",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Make practical of; employ",
                "answer": "USE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Groan of distaste",
                "answer": "UGH",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Take in with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Artists who work with plate and acid",
                "answer": "ETCHERS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A make-do measure for now",
                "answer": "STOPGAP",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Just so; agreed",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Come to have",
                "answer": "GET",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Bullies with words",
                "answer": "HECTORS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Metal of many a soup can",
                "answer": "TIN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Joint below the waist; with-it, in old slang",
                "answer": "HIP",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "One who settles an old score",
                "answer": "AVENGER",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "By way of; passing through",
                "answer": "VIA",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "A fire engine’s color",
                "answer": "RED",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A polite word for a gentleman",
                "answer": "SIR",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Possesses",
                "answer": "HAS",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "A soft cushion to write upon",
                "answer": "PAD",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0058",
        "size": "midi",
        "difficulty": "medium",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look; \"come and ___\"",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Adjust a clock to the right time",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One stuck on himself",
                "answer": "EGOTIST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Lilting song style of the islands",
                "answer": "CALYPSO",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long while back",
                "answer": "AGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Played casually, as on a flute",
                "answer": "TOOTLED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A male cat",
                "answer": "TOM",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "A plaything",
                "answer": "TOY",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A quick partial look",
                "answer": "GLIMPSE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Room full of exercise gear",
                "answer": "GYM",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "The sheltered side, out of the wind",
                "answer": "LEE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Cut wood; or spotted",
                "answer": "SAW",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Organ you see with, one of a pair",
                "answer": "EYE",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Agreeable answer, the opposite of no",
                "answer": "YES",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Speak your piece",
                "answer": "SAY",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Was introduced to; \"We ___ years ago\"",
                "answer": "MET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Be in debt",
                "answer": "OWE",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0059",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "K",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "O",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "G",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Away from home, as when running errands",
                "answer": "OUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to good purpose",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "What geometry students prove",
                "answer": "THEOREM",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "The knack for doing something",
                "answer": "ABILITY",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A grocery sack",
                "answer": "BAG",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "\"In ___ with\" (matching)",
                "answer": "KEEPING",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Barnyard oinker",
                "answer": "PIG",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What squeaky hinges need",
                "answer": "OIL",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "On the big side",
                "answer": "LARGISH",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A ship captain's daily record",
                "answer": "LOG",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Whichever one at all",
                "answer": "ANY",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Take a look at",
                "answer": "SEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Possesses",
                "answer": "HAS",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Afternoon cuppa",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Room full of exercise gear",
                "answer": "GYM",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Word of agreement; a nod of approval",
                "answer": "YES",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0060",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take a look with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "The lady; a female being spoken of",
                "answer": "SHE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Have a meal",
                "answer": "EAT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One who slipped away",
                "answer": "ESCAPEE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A small flaw",
                "answer": "BLEMISH",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Possesses",
                "answer": "HAS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A fib; or stretch out",
                "answer": "LIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Artists who work with plate and acid",
                "answer": "ETCHERS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A smash success",
                "answer": "HIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Line up the shot",
                "answer": "AIM",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A turtle or a lizard",
                "answer": "REPTILE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Rodent that scurries through the cellar",
                "answer": "RAT",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Sheltered side, away from the wind",
                "answer": "LEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "The salty blue expanse",
                "answer": "SEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "The lady over there",
                "answer": "HER",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0061",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "P",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Slow ___ steady wins the race\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to good ___",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Royal seats",
                "answer": "THRONES",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A male sheep",
                "answer": "RAM",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Cashes in, as coupons",
                "answer": "REDEEMS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "What you look at the world with",
                "answer": "MAD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Laughed to scorn",
                "answer": "DERIDED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "What fills a fountain pen",
                "answer": "INK",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "The loneliest number",
                "answer": "ONE",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A common eye irritation",
                "answer": "PINKEYE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Settle the bill",
                "answer": "PAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Vote of agreement",
                "answer": "YEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Where a road or a movie finishes",
                "answer": "END",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Gentlemen",
                "answer": "MEN",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "A nod of agreement",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Down in the dumps",
                "answer": "SAD",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0062",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"Better late ___ never\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work, as a tool",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "A course of treatment",
                "answer": "THERAPY",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A plaything",
                "answer": "TOY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "What a pedicure trims",
                "answer": "TOENAIL",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Belonging to oneself",
                "answer": "OWN",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Just so; agreed",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Be in debt",
                "answer": "OWE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Grows more profound",
                "answer": "DEEPENS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "It sizzles on the stove",
                "answer": "PAN",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Went on foot, quickly",
                "answer": "RAN",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Flow outward from a source",
                "answer": "EMANATE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "An adult fellow",
                "answer": "MAN",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "The finish",
                "answer": "END",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "A charged particle",
                "answer": "ION",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Whichever one at all",
                "answer": "ANY",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Guided the way, in the past tense",
                "answer": "LED",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0063",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "W",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "\"All ___ one, and one for all\"",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Not good at all",
                "answer": "BAD",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Make good of; put to work",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Where the curtain rises",
                "answer": "THEATER",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Bashful and timid",
                "answer": "SHY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Hi-fi sets",
                "answer": "STEREOS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Belonging to him",
                "answer": "HIS",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Up to now",
                "answer": "YET",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Fasten a shoelace in a bow",
                "answer": "TIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Farthest down",
                "answer": "DEEPEST",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A peach's stone",
                "answer": "PIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "What the postman brings, or A to Z",
                "answer": "LETTERS",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "What Congress passes",
                "answer": "LAW",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A light knock",
                "answer": "RAP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "The blue expanse overhead",
                "answer": "SKY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Mighty tree from a little acorn",
                "answer": "OAK",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The opposite of peace",
                "answer": "WAR",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0064",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Take notice of with your eyes",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Put in place; ready to go",
                "answer": "SET",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "One's pride or self-regard",
                "answer": "EGO",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "One stuck on himself",
                "answer": "EGOTIST",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Uncooked, as vegetables",
                "answer": "RAW",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Fills the camera with fresh film, say",
                "answer": "RELOADS",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Used to be",
                "answer": "WAS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What a hen lays",
                "answer": "EGG",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long age or span of time",
                "answer": "ERA",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Plays lightly, as a flute",
                "answer": "TOOTLES",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Two thousand pounds, in weight",
                "answer": "TON",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "As well",
                "answer": "TOO",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "The leafy greens that made Popeye strong",
                "answer": "SPINACH",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Bashful and timid",
                "answer": "SHY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Dessert in a tin, often apple",
                "answer": "PIE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "It holds your morning coffee",
                "answer": "CUP",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Greeting to get attention",
                "answer": "HEY",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Belonging to that fellow",
                "answer": "HIS",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Owed by now",
                "answer": "DUE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "Up to now",
                "answer": "YET",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Cloak-and-dagger agent",
                "answer": "SPY",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0065",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "F",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "F",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "D",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Word right before \"end\" or \"top\"",
                "answer": "THE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Afternoon brew",
                "answer": "TEA",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Owned, in the past",
                "answer": "HAD",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "The slow wearing of wind and water",
                "answer": "EROSION",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "A long way off",
                "answer": "FAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "\"Survival of the ___\"",
                "answer": "FITTEST",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Cardinal colour",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "You hear with it",
                "answer": "EAR",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Taken into the family",
                "answer": "ADOPTED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "For each, in pricing",
                "answer": "PER",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Group of related items, like dishes or tools",
                "answer": "SET",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "\"Mirror, mirror\" superlative",
                "answer": "FAIREST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Looked after, as a hungry crowd",
                "answer": "FED",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Number after nine",
                "answer": "TEN",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A person's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Use your eyes to look",
                "answer": "SEE",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "A wild animal's home, or a cozy study at home",
                "answer": "DEN",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "What a beach day may give you",
                "answer": "TAN",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0066",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "'Last ___ not least'",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work; employ",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Showed gratitude to",
                "answer": "THANKED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sacred work Bach wrote by the hundred",
                "answer": "CANTATA",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "A long span of time",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "In the past; \"long ___\"",
                "answer": "AGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Ached with longing",
                "answer": "YEARNED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "The opposite of yes",
                "answer": "NOT",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Clumsy and ill at ease",
                "answer": "AWKWARD",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Had a meal, in past tense",
                "answer": "ATE",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Come out on top",
                "answer": "WIN",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A stop light’s color",
                "answer": "RED",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "A child's affectionate name for father",
                "answer": "DAD",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Fasten the laces in a bow",
                "answer": "TIE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Afternoon drink",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The very last bit",
                "answer": "END",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Sum up; tack on",
                "answer": "ADD",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0067",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Catch a glimpse of",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Pronoun for a woman",
                "answer": "SHE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Teach and bring up",
                "answer": "EDUCATE",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "The opposite of peace",
                "answer": "WAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Quicker with a quip",
                "answer": "WITTIER",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "A stop sign’s color",
                "answer": "RED",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Owned, in the past",
                "answer": "HAD",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "It chills your drink",
                "answer": "ICE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Blew its top, as a volcano",
                "answer": "ERUPTED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Set in place",
                "answer": "PUT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Snip with scissors",
                "answer": "CUT",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Having to do with space",
                "answer": "SPATIAL",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "The salty blue expanse",
                "answer": "SEA",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Average score on a golf hole",
                "answer": "PAR",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "In times past; previously",
                "answer": "AGO",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Opposite of high",
                "answer": "LOW",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Have a bite of breakfast or lunch",
                "answer": "EAT",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "One's sense of self-importance",
                "answer": "EGO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "\"Here we ___\"",
                "answer": "ARE",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0068",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "B",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "K",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "W",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "T",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "On the contrary; however",
                "answer": "BUT",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Put to work",
                "answer": "USE",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Showed gratitude to",
                "answer": "THANKED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "It rolls down the road",
                "answer": "CAR",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "Sacred work Bach wrote by the hundred",
                "answer": "CANTATA",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "How old you are",
                "answer": "AGE",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Fishing pole",
                "answer": "ROD",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "What's left in the fireplace",
                "answer": "ASH",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A long while back",
                "answer": "AGO",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Ached with longing",
                "answer": "YEARNED",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "Move a boat with oars",
                "answer": "ROW",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "'Whether or ___'",
                "answer": "NOT",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Clumsy and ill at ease",
                "answer": "AWKWARD",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Had a meal earlier today",
                "answer": "ATE",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Came out on top; was victorious",
                "answer": "WON",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "The color of a ripe tomato",
                "answer": "RED",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Father, fondly",
                "answer": "DAD",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Hot drink steeped from leaves in a cup",
                "answer": "TEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The very last part",
                "answer": "END",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Sum up; tack on",
                "answer": "ADD",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0069",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "B",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "Y",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "M",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "R",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "P",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "I",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "L",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "M",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Lay eyes upon",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "That woman",
                "answer": "SHE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Have a bite of food",
                "answer": "EAT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Got away",
                "answer": "ESCAPED",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Water in a curve of the coast",
                "answer": "BAY",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "A small flaw",
                "answer": "BLEMISH",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "What you breathe",
                "answer": "AIR",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Agreeable answer, the opposite of no",
                "answer": "YES",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Possesses",
                "answer": "HAS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "A fib; or stretch out",
                "answer": "LIE",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Artists who work with plate and acid",
                "answer": "ETCHERS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A smash success",
                "answer": "HIT",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Line up the shot",
                "answer": "AIM",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "A turtle or a lizard",
                "answer": "REPTILE",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "A male sheep",
                "answer": "RAM",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "A long period of history",
                "answer": "ERA",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "The sheltered side, away from the wind",
                "answer": "LEE",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "You hear with it",
                "answer": "EAR",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "They exist; the verb of being",
                "answer": "ARE",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "Large body of salt water",
                "answer": "SEA",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "What you look at the world with",
                "answer": "MAD",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "Belonging to that woman",
                "answer": "HER",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    },
    {
        "id": "midi-gen-0071",
        "size": "midi",
        "difficulty": "easy",
        "rows": 7,
        "cols": 7,
        "grid": [
            [
                {
                    "block": false,
                    "solution": "S",
                    "number": 1
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 2
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 3
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 4
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": 5
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 6
                }
            ],
            [
                {
                    "block": false,
                    "solution": "H",
                    "number": 7
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 8
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "D",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "E",
                    "number": 9
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "H",
                    "number": 10
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                }
            ],
            [
                {
                    "block": true
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 11
                },
                {
                    "block": false,
                    "solution": "U",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": true
                }
            ],
            [
                {
                    "block": false,
                    "solution": "L",
                    "number": 12
                },
                {
                    "block": false,
                    "solution": "A",
                    "number": 13
                },
                {
                    "block": false,
                    "solution": "R",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "G",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": 14
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 15
                }
            ],
            [
                {
                    "block": false,
                    "solution": "A",
                    "number": 16
                },
                {
                    "block": false,
                    "solution": "C",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "T",
                    "number": 17
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": null
                }
            ],
            [
                {
                    "block": false,
                    "solution": "Y",
                    "number": 18
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "S",
                    "number": null
                },
                {
                    "block": true
                },
                {
                    "block": false,
                    "solution": "O",
                    "number": 19
                },
                {
                    "block": false,
                    "solution": "N",
                    "number": null
                },
                {
                    "block": false,
                    "solution": "E",
                    "number": null
                }
            ]
        ],
        "clues": [
            {
                "number": 1,
                "direction": "across",
                "clue": "Do you ___ what I mean?",
                "answer": "SEE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 1,
                "direction": "down",
                "clue": "A lady",
                "answer": "SHE",
                "row": 0,
                "col": 0,
                "length": 3
            },
            {
                "number": 2,
                "direction": "down",
                "clue": "Have your dinner",
                "answer": "EAT",
                "row": 0,
                "col": 1,
                "length": 3
            },
            {
                "number": 3,
                "direction": "down",
                "clue": "Sees safely to the door",
                "answer": "ESCORTS",
                "row": 0,
                "col": 2,
                "length": 7
            },
            {
                "number": 4,
                "direction": "across",
                "clue": "Hot drink steeped in a cup",
                "answer": "TEA",
                "row": 0,
                "col": 4,
                "length": 3
            },
            {
                "number": 4,
                "direction": "down",
                "clue": "To that; \"attached ___\" (formal)",
                "answer": "THERETO",
                "row": 0,
                "col": 4,
                "length": 7
            },
            {
                "number": 5,
                "direction": "down",
                "clue": "Part of the head used for listening",
                "answer": "EAR",
                "row": 0,
                "col": 5,
                "length": 3
            },
            {
                "number": 6,
                "direction": "down",
                "clue": "Newspaper notices selling things",
                "answer": "ADS",
                "row": 0,
                "col": 6,
                "length": 3
            },
            {
                "number": 7,
                "direction": "across",
                "clue": "Possesses",
                "answer": "HAS",
                "row": 1,
                "col": 0,
                "length": 3
            },
            {
                "number": 8,
                "direction": "across",
                "clue": "Owned, in the past",
                "answer": "HAD",
                "row": 1,
                "col": 4,
                "length": 3
            },
            {
                "number": 9,
                "direction": "across",
                "clue": "Artists who work with plate and acid",
                "answer": "ETCHERS",
                "row": 2,
                "col": 0,
                "length": 7
            },
            {
                "number": 10,
                "direction": "down",
                "clue": "A warm, wrapped-arms greeting",
                "answer": "HUG",
                "row": 2,
                "col": 3,
                "length": 3
            },
            {
                "number": 11,
                "direction": "across",
                "clue": "Belonging to us",
                "answer": "OUR",
                "row": 3,
                "col": 2,
                "length": 3
            },
            {
                "number": 12,
                "direction": "across",
                "clue": "Biggest of all",
                "answer": "LARGEST",
                "row": 4,
                "col": 0,
                "length": 7
            },
            {
                "number": 12,
                "direction": "down",
                "clue": "Put down gently",
                "answer": "LAY",
                "row": 4,
                "col": 0,
                "length": 3
            },
            {
                "number": 13,
                "direction": "down",
                "clue": "Playing card just above the two",
                "answer": "ACE",
                "row": 4,
                "col": 1,
                "length": 3
            },
            {
                "number": 14,
                "direction": "down",
                "clue": "A man's male child",
                "answer": "SON",
                "row": 4,
                "col": 5,
                "length": 3
            },
            {
                "number": 15,
                "direction": "down",
                "clue": "Little piggy, in the rhyme",
                "answer": "TOE",
                "row": 4,
                "col": 6,
                "length": 3
            },
            {
                "number": 16,
                "direction": "across",
                "clue": "A single deed, or a part of a play",
                "answer": "ACT",
                "row": 5,
                "col": 0,
                "length": 3
            },
            {
                "number": 17,
                "direction": "across",
                "clue": "As well",
                "answer": "TOO",
                "row": 5,
                "col": 4,
                "length": 3
            },
            {
                "number": 18,
                "direction": "across",
                "clue": "The opposite of no",
                "answer": "YES",
                "row": 6,
                "col": 0,
                "length": 3
            },
            {
                "number": 19,
                "direction": "across",
                "clue": "The number after zero",
                "answer": "ONE",
                "row": 6,
                "col": 4,
                "length": 3
            }
        ],
        "attribution": "Generated by tools/crossword-build (midi clue pool). Fill: Spread the Word(list) (CC BY-NC-SA 4.0; list not redistributed) ∩ ENABLE (public domain); difficulty via wordfreq (Apache-2.0). Clues filled from the build clue pool."
    }
];
//# sourceMappingURL=generated-midi.js.map